import React from 'react';

import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import FoundItLowerButton from '../../../../components/found-it-lower-button/found-it-lower-button';
import ParentProductMessage from '../../../../components/parent-product-message/parent-product-message';
import Price from '../../../../components/price/price';
import StackedMarkdownPrice from '../../../../components/stacked-markdown-price/stacked-markdown-price';

import { useFitment } from '../../../../shared/hooks/hooks';

import { isProductTrailerOrLawn } from '../../../../shared/utils/cart/cart';
import {
  getPriceInfo,
  isCanonicalProduct
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-list-card-price.scss';

interface ProductListCardPriceProps {
  className?: string;
  hideFoundItLower?: boolean;
  hideParentMessage?: boolean;
  hidePercentageSaved?: boolean;
  product?: ProductData;
  quantity: number;
  showStaticQuantity?: boolean;
  totalQuantity?: number;
}

function ProductListCardPrice(props: ProductListCardPriceProps) {
  const {
    className = '',
    hideFoundItLower = false,
    hideParentMessage = false,
    hidePercentageSaved = false,
    product,
    quantity,
    showStaticQuantity = false,
    totalQuantity
  } = props;

  const { selectedFitment } = useFitment();

  if (!product) return null;

  const { unitName } = product;
  const isCanonical = isCanonicalProduct(product);
  const priceInfo = getPriceInfo(product);

  return (
    <div
      className={`${className} "product-list-card-price"`}
      styleName="container"
    >
      <div data-testid="product-list-card-price_line" styleName="price-line">
        <StackedMarkdownPrice
          hidePercentageSaved={hidePercentageSaved}
          product={product}
        />
        <Price
          mapPrice={priceInfo?.mapPrice}
          price={priceInfo?.price}
          priceRange={priceInfo?.priceRange}
          styleName="price"
          unitName={unitName}
          variant="H3"
        />

        {showStaticQuantity && (
          <Typography styleName="static-quantity" tag="span">
            QTY: 4
          </Typography>
        )}
      </div>

      {!hideFoundItLower && (
        <FoundItLowerButton
          productItem={{
            product: product,
            quantity: quantity,
            totalQuantity: totalQuantity
          }}
        />
      )}

      {!hideParentMessage && <ParentProductMessage product={product} />}

      {isCanonical && (
        <Typography size="small" styleName="exact-price-msg" tag="div">
          {selectedFitment
            ? 'View details for price & inventory'
            : !isProductTrailerOrLawn(product) && (
                <>
                  <Link
                    size="small"
                    styleName="vehicle-link"
                    to="#/fitment/vehicle"
                  >
                    enter vehicle
                  </Link>{' '}
                  for exact price & inventory
                </>
              )}
        </Typography>
      )}
    </div>
  );
}

export default ProductListCardPrice;
